import { Controller } from "@hotwired/stimulus"

// Rewrites the landing's placeholder cart links to the real Astro cart, which reads
// ?add=<sign>|collection (&gift=1) on load. Ported from the LP's inline cart IIFE.
// Classic JS only (old Babel — no ?./??).
const CART = "/box-livre-astro/cart"

export default class extends Controller {
  connect() {
    // Fiche CTAs: "Je la veux" → add sign; "Je l'offre" → add sign + gift.
    this.element.querySelectorAll(".fiche[data-sign]").forEach((art) => {
      const sign = art.dataset.sign
      const buy = art.querySelector(".fiche-btn-primary")
      const offer = art.querySelector(".fiche-btn-ghost")
      if (buy) buy.setAttribute("href", this.cartHref(sign, false))
      if (offer) offer.setAttribute("href", this.cartHref(sign, true))
    })

    // Grand tour → collection.
    this.element.querySelectorAll(".grand-tour-cta").forEach((a) => {
      a.setAttribute("href", CART + "?add=collection")
    })

    // Final-CTA tiles → direct add for that sign.
    this.element.querySelectorAll(".final-tile[data-sign]").forEach((a) => {
      a.setAttribute("href", this.cartHref(a.dataset.sign, false))
    })
  }

  cartHref(sign, gift) {
    let href = CART + "?add=" + sign
    if (gift) href += "&gift=1"
    return href
  }
}
